import { LayerProps } from 'shared/map-exports';
import { useMemo } from 'react';
import {
  ExternalFeatureLayerProps,
  ExternalLayerStylesInput,
} from './ExternalFeatureLayer.types';
import { EmbeddedStylePointLayer } from './EmbeddedPointLayer';

type PointLayerProps = ExternalFeatureLayerProps;

const getPointLayerStyles = (input: ExternalLayerStylesInput): LayerProps => {
  if (input.displayStyleType !== 'simple_single_color') {
    throw new Error(
      'Point layer styles require simple_single_color display style',
    );
  }
  const { sourceLayer, color } = input;
  return {
    type: 'symbol',
    'source-layer': sourceLayer,
    layout: {
      'icon-image': 'CustomLayerLocationPin',
      'icon-allow-overlap': true,
      'icon-anchor': 'bottom',
      'icon-ignore-placement': true,
    },
    paint: {
      'icon-color': color,
    },
  };
};

export const SimplePointLayer = (props: PointLayerProps): JSX.Element => {
  const { sourceId, featureLayer, visible } = props;
  const { shortName, displayStyleData } = featureLayer;

  const updatedFeatureLayer = useMemo(() => {
    const pointStyle = getPointLayerStyles({
      sourceLayer: shortName,
      ...displayStyleData,
    });
    const featureLayerCopy = { ...featureLayer };
    featureLayerCopy.displayStyleData = {
      layers: [{ ...pointStyle, id: `${sourceId}_point` }],
      clickListenerLayerId: `${sourceId}_point`,
      displayStyleType: 'embedded',
    };
    return featureLayerCopy;
  }, [sourceId, shortName, displayStyleData, featureLayer]);

  return (
    <EmbeddedStylePointLayer
      visible={visible}
      sourceId={sourceId}
      featureLayer={updatedFeatureLayer}
    />
  );
};
